var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import Link from '../Link/Link';
import { uid } from '../_utils';
var DropdownItem = function (props) {
    var _a = props.id, id = _a === void 0 ? uid('dropdown-item') : _a, text = props.text, _b = props.to, to = _b === void 0 ? '/' : _b, _c = props.disabled, disabled = _c === void 0 ? false : _c, _d = props.iconClass, iconClass = _d === void 0 ? '' : _d, onClick = props.onClick;
    var getCustomProps = function () {
        return disabled ? { 'aria-disabled': true, tabIndex: -1 } : {};
    };
    return (React.createElement("li", { id: id, role: "presentation", onClick: function (nativeEvent) {
            nativeEvent === null || nativeEvent === void 0 ? void 0 : nativeEvent.stopPropagation();
            onClick === null || onClick === void 0 ? void 0 : onClick(nativeEvent);
        }, style: { listStyleType: 'none' } },
        !onClick && (React.createElement(Link, __assign({ to: to, className: "dropdown-item" + (disabled ? ' disabled' : '') }, getCustomProps()), text ? text : 'Item')),
        !!onClick && (React.createElement("button", { role: "menuitem", type: "button", className: "dropdown-item" },
            !!iconClass && React.createElement("i", { className: "fal " + iconClass + " mr-2" }),
            text))));
};
export default React.memo(DropdownItem);
